export default "__VITE_ASSET__B$gdl9Kv__"